import Analytics from '@monolith/legacy/services/analytics';
import CustomerEmailPrefilled from '@monolith/legacy/services/analytics/events/customer-email-prefilled-event';
import { RetailerFormType } from '@monolith/legacy/types/retailer-form-type';
import { AuthFormType } from '@monolith/legacy/types/auth-form-type';
import type { LiftPromocode } from '@monolith/legacy/types/order';
import type { AuthPopinData, AuthPopinFormType, AuthPopinProps } from '@monolith/legacy/types/auth-popin';

interface AuthPopinDeps {
  dispatch: (action: string, payload?: unknown) => Promise<unknown>;
  getBrandById: (id: string) => { name: string; lift_promocode?: LiftPromocode } | null;
  fetchBrandData: (brandId: string) => Promise<void>;
  getWrapper: () => { openModal: (props: AuthPopinProps) => void } | null;
}

export async function openAuthPopinHandler(
  deps: AuthPopinDeps,
  view: AuthPopinFormType,
  data: AuthPopinData | null = {},
  successCallback?: () => void,
) {
  const dataLocal = data || {};
  const { email = '', isReminded = false } = dataLocal;
  const params = new URLSearchParams(window.location.search);
  const brandId = dataLocal.brandId || params.get('liftBrandId');

  if (view === RetailerFormType.Register) {
    await deps.dispatch('showSignup');
    if (email?.length > 0) {
      void Analytics.track(new CustomerEmailPrefilled(email));
    }
  }

  let brandName: string | undefined;
  let liftCode: LiftPromocode | undefined;

  if (brandId) {
    if (!deps.getBrandById(brandId)) {
      await deps.fetchBrandData(brandId);
    }
    const brand = deps.getBrandById(brandId);
    if (brand) {
      brandName = brand.name;
      liftCode = brand.lift_promocode;
    }
  }

  const wrapper = deps.getWrapper();
  if (!wrapper) {
    return;
  }

  wrapper.openModal({
    // The popin never hosts the retailer wizard (that lives on the /register page);
    // a Register entry always opens the shared email step here.
    view: view === RetailerFormType.Register ? AuthFormType.EmailOnlySignUp : view,
    successCallback,
    email: email || undefined,
    data: {
      brandId,
      isReminded,
      brandName,
      liftCode,
    },
  });
}
